import { Grid, Typography } from '@mui/material';
import { Dashboard } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { ROUTE_PATHS } from 'app/utils/route';
import RequestPageIcon from '@mui/icons-material/RequestPage';
export const BrowseHeader = () => {
    return (
        <Grid container direction="row" alignItems="center" sx={{ p: 3 }}>
            <Grid item>
                <RequestPageIcon fontSize="large" />
            </Grid>
            <Grid item sx={{ pl: 1 }}>
                
                <Typography
                    variant="h5"
                    // onClick={() => navigate(`/${ROUTE_PATHS.browse}`)}
                >
                    Price Requests By Group
                </Typography>
            </Grid>
        </Grid>
    );
};
